import React, { useState, useEffect } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Texas } from "./components/texas";
import { Services } from "./components/services";
import { ProjectShowcase } from "./components/ProjectShowcase";
import { Team } from "./components/Team";
import { Training } from "./components/training";
import { Customers } from "./components/Customers";
import { Contact } from "./components/contact";
import GovernmentContracts from "./components/GovernmentContracts";
import Contract5373 from "./components/Contract5373";
import Contract6167 from "./components/Contract6167";
import DirDisclaimer from "./components/DirDisclaimer";
import FadeWrapper from "./components/FadeWrapper"; // 👈 Import wrapper
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const location = useLocation();
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 0);
      }
    }
  }, [location]);

  return (
    <Switch>
      <Route exact path="/">
        <Navigation /> {/* Do NOT wrap this in FadeWrapper */}
        <DirDisclaimer autoHideMs={10000} />
        <FadeWrapper>
          <Header data={landingPageData.Header} />
          <Customers data={landingPageData.Customers} />
          <Services data={landingPageData.Services} />
          <Texas data={landingPageData.Texas} />
          <Training data={landingPageData.Training} />
          <About data={landingPageData.About} />
          <ProjectShowcase />
          <Team data={landingPageData.Team} />
          <Contact data={landingPageData.Contact} />
        </FadeWrapper>
      </Route>

      <Route exact path="/government-contracts">
        <Navigation />
        <DirDisclaimer />
        <FadeWrapper>
          <GovernmentContracts />
        </FadeWrapper>
      </Route>

      <Route path="/government-contracts/dir-cpo-5373">
        <Navigation />
        <DirDisclaimer />
        <FadeWrapper>
          <Contract5373 />
        </FadeWrapper>
      </Route>

      <Route path="/government-contracts/dir-cpo-6167">
        <Navigation />
        <DirDisclaimer />
        <FadeWrapper>
          <Contract6167 />
        </FadeWrapper>
      </Route>
    </Switch>
  );
};

export default App;
